import { manualInstructions } from "./base";

export default props =>
  manualInstructions({
    ...props,
    os: "redhat",
    dist: "7",
  });
